<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import faqCategoryList from "./faq-category-list";
    export default {
    components: { Layout, PageHeader, faqCategoryList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <faq-category-list/>
  </Layout>
</template>